const imagePath = '/imgs'

import heroImg from '../assets/images/hero.webp'

export const webAssets = {
  /**
   * LAYOUTS
   */
  logoLight: `${imagePath}/logo.webp`,
  logoDark: `${imagePath}/logo-dark.webp`,
  google: `${imagePath}/google.svg`,
  location: `${imagePath}/location.svg`,
  facebookFooter: `${imagePath}/FaceBook.svg`,
  instagramFooter: `${imagePath}/Instagram.svg`,
  linkedinFooter: `${imagePath}/Linkedin.svg`,

  /**
   * BLOCKS
   */

  // welcome
  heroImg,
  // HowItWorks
  howItWorks1: `${imagePath}/how-it-works-1.webp`,
  howItWorks2: `${imagePath}/how-it-works-2.webp`,
  howItWorks3: `${imagePath}/how-it-works-3.webp`,
  // About Us
  aboutUs1: `${imagePath}/about-us-1.webp`,
  aboutUs2: `${imagePath}/about-us-2.webp`,
  aboutUs3: `${imagePath}/about-us-3.webp`,
  // WhyUs
  whyUsImg: `${imagePath}/why-us.webp`,
  wifi: `${imagePath}/wifi.webp`,
  socialNetwork: `${imagePath}/social-network.webp`,
  timeFast: `${imagePath}/time-fast.webp`,
  handshakeAngle: `${imagePath}/handshake-angle.webp`,
  global: `${imagePath}/global.webp`,
  // CallCenter
  CallCenterImg: `${imagePath}/Call Center.webp`,
  callCalling: `${imagePath}/call-calling.webp`,
  clock: `${imagePath}/clock.webp`,
  // Service Details
  subtract: `${imagePath}/Subtract.webp`,

  // Inside dashboard
  sentSuccessfully: `${imagePath}/sent-successfully.svg`,
  // subscription 
  subscriptionBg: `${imagePath}/subscription.svg`,

  // Branches
  branchesMap: `${imagePath}/branches-map.webp`,

  // App download banner
  appBannerMoneyBag: `${imagePath}/app-banner/icon-money-bag.svg`,
  appBannerLinkForward: `${imagePath}/app-banner/icon-link-forward.svg`,
  appBannerOkFinger: `${imagePath}/app-banner/icon-ok-finger.svg`,
  appBannerPhoneSilver: `${imagePath}/app-banner/iphone-frame-silver.svg`,
  appBannerPhoneGold: `${imagePath}/app-banner/iphone-frame-gold.svg`,
  appBannerPhoneDark: `${imagePath}/app-banner/iphone-frame-dark.svg`,
  appBannerScreenThankYou: `${imagePath}/app-banner/app-screen-thank-you.webp`,
  appBannerScreenPackage: `${imagePath}/app-banner/app-screen-package-order.webp`,
  appBannerScreenPackages: `${imagePath}/app-banner/app-screen-mum-package.webp`,
}
